import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Изменить компанию",
    loading: _ctx.isLoading,
    onConfirm: _ctx.emitSubmit,
    onCancel: _ctx.emitCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        value: _ctx.state.companyId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.companyId) = $event)),
        placeholder: "Выберите компанию",
        label: "name",
        "search-by": "name",
        options: _ctx.data_state.list,
        loading: _ctx.data_state.is_loading,
        failed: _ctx.data_state.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        "infinite-scroll": "",
        onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.pagination.current_page))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFoundCompany
      }, null, 8, ["value", "options", "loading", "failed", "onSearch", "onOptionBySearch"])
    ]),
    _: 1
  }, 8, ["loading", "onConfirm", "onCancel"]))
}